export enum ActiveStatus {
    ACTIVE = 'active',
    DISABLED = 'disabled'
};

export enum UserRole {
    ADMIN = 'admin',
    STAFF = 'staff'
};

export enum TemplateType {
    RESUME = "resume",
    COVER_LETTER = "cover-letter",
};

export enum ContentShowcase {
    ORIGINAL = "original",
    AI = "ai",
};

export enum SummaryType {
    PROFESSIONAL = "professional",
    OBJECTIVE = "objective",
};

export enum MediaSourceType {
    UPLOADED = "uploaded",
    CREATED = "created",
};

export enum MediaSource {
    RESUME = "resume",
    INTERVIEW_QUESTION_RESPONSE = "interview-question-response",
    COVER_LETTER = "cover-letter",
}

export enum MediaType {
    PDF = "pdf",
    DOCX = "docx",
    AUDIO = "audio",
    VIDEO = "video",
};

export enum SocialLinkType {
    LINKEDIN = "linkedin",
    GITHUB = "github",
    X = "x",
    INSTAGRAM = "instagram",
    FACEBOOK = "facebook",
    YOUTUBE = "youtube",
    TIKTOK = "tiktok",
};

export enum HighlightSource {
    WORK = "work",
    EDUCATION = "education",
    PROJECT = "project",
};

export enum HideShowAction {
    SHOW = "show",
    HIDE = "hide",
};

export interface ISelectDropdownOption {
    value: string;
    label: string;
    disabled?: boolean;
};

export enum ScanCriteriaType {
    RESUME = "resume",
    COVER_LETTER = "cover-letter",
    INTERVIEW = "interview"
}

export enum ScanCriteriaLevel {
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
}


export enum InterviewMode {
    VIDEO = "video",
    AUDIO = "audio",
};

export enum InterviewQuestionType {
    TECHNICAL = "technical",
    BEHAVIORAL = "behavioral",
    BOTH = "both",
};

export enum StudentOnboardingResponseOptionsField {
    CURRENT_STATUS = 'current_status',
    CAREER_INTEREST = 'career_interest',
    CURRENT_IMMIGRATION_STATUS = 'current_immigration_status',
    PROGRAM_OF_STUDY = 'program_of_study',
};